import React, { useEffect, useState } from 'react';
import { SpinnerSize, Spinner, Text, PrimaryButton, Modal } from '@fluentui/react';
import { useHistory, Link } from 'react-router-dom';
import DetailsPanel from 'app/modules/user/detailsPanel/DetailsPanel';
import { useParams } from 'react-router-dom';
import './RequestDetails.scss';
import { Trans } from 'react-i18next';
import { useGetRequestById, useRequestTypesLookUpData, useTeamLookUpData } from 'app/services/request-api';
import { useBoolean } from '@fluentui/react-hooks';
import { isAdmin, isSuperAdmin, isUser } from 'app/utils/authUtilities';
import useStore, { IStore } from 'app/store';
import { EnumLookUp, RequestDto, UserDto } from 'generated/request-backend';

interface IParams {
    id: string;
}

/**
 * This needed to be fetched from API. Temporary variable
 */
const statusTypes = [
    new EnumLookUp({ id: 1, name: 'New' }),
    new EnumLookUp({ id: 2, name: 'Active' }),
    new EnumLookUp({ id: 3, name: 'In Progress' }),
    new EnumLookUp({ id: 4, name: 'Resolved' }),
    new EnumLookUp({ id: 5, name: 'Closed' })
];

const RequestDetails: React.FC = (props) => {
    let history = useHistory();
    //set variables
    const [selectedRequest, setSelectedRequest] = useState<RequestDto>();
    const userDetails: UserDto = useStore((state: IStore) => state.userDetails as UserDto);
    // skp id from url
    const { id: requestId } = useParams<IParams>();

    // queries
    const {
        data: apiRequestData,
        isLoading: isLoadingRequestList,
        isError: isErrorRequestDetails,
        isSuccess: isSuccessRequestDetails
    } = useGetRequestById(requestId);
    const { data: requestTypes } = useRequestTypesLookUpData();
    const { data: teams } = useTeamLookUpData();
    useEffect(() => {
        if (!isLoadingRequestList) {
            setSelectedRequest(apiRequestData);
        }
    }, [apiRequestData, isLoadingRequestList, selectedRequest]);
    const [isModalOpen, { setTrue: showModal, setFalse: hideModal }] = useBoolean(false);
    useEffect(() => {
        if (!isLoadingRequestList && apiRequestData) {
            if ((isUser(userDetails?.userRoles) && apiRequestData?.isHidden) || apiRequestData?.isParent) {
                showModal();
            }
        }
    }, [isLoadingRequestList]);

    return (
        <div className="container request-details-container">
            {isLoadingRequestList && (
                <div className="m-t-50 loader-container">
                    <Spinner label="Search results are loading. Please wait..." size={SpinnerSize.large} />
                </div>
            )}
            {<div></div>}
            <Modal className="hidden-request-modal" isOpen={isModalOpen} onDismiss={hideModal} isBlocking={true}>
                {apiRequestData?.isParent ? (
                    <Text className="modal-content">
                        The request {apiRequestData?.unifiedTrackingId} cannot be viewed as a non-admin. Please try searching by the ticket title.
                    </Text>
                ) : (
                    <Text className="modal-content">
                        Your request has been hidden by the administrator. If you have a concern, please log it in the feedback
                        window.
                    </Text>
                )}

                <div className="modal-footer">
                    <Link to={apiRequestData?.isParent ? '/unified-dashboard' : '/submit-feedback'}>
                        <PrimaryButton text="OK" />{' '}
                    </Link>
                </div>
            </Modal>
            {!isLoadingRequestList &&
            (isSuccessRequestDetails || isErrorRequestDetails) &&
            (isAdmin(userDetails?.userRoles) || isSuperAdmin(userDetails?.userRoles) || !apiRequestData?.isHidden) &&
            !apiRequestData?.isHidden ? (
                <div>
                    {!isLoadingRequestList && (
                        <p>
                            <Link role="link" to="" tabIndex={0} onClick={() => history.goBack()} className="back-request">
                                <span className="arrow-icon"></span>

                                {!isLoadingRequestList && isSuccessRequestDetails && apiRequestData.summary}
                            </Link>
                        </p>
                    )}
                    <div className="unified-dashboard-container ">
                        {!isLoadingRequestList && isSuccessRequestDetails && !apiRequestData.isParent && (
                            <DetailsPanel
                                teams={teams}
                                selectedRequest={selectedRequest}
                                requestTypes={requestTypes}
                                statusTypes={statusTypes}
                                setSelectedRequest={setSelectedRequest}
                                pageType="DETAILS_PAGE"
                            />
                        )}
                        {!isLoadingRequestList && (isErrorRequestDetails || apiRequestData.isParent) && (
                            <div className="no-results-wrap">
                                <Trans>The requested details are not available</Trans>.
                            </div>
                        )}
                    </div>
                </div>
            ) : (
                <div className="dummy-space"></div>
            )}
        </div>
    );
};

export default RequestDetails;
